import {Controller} from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'profile--legal-aid-edit-modal'
    ];

    openEditModal(event) {
        event.preventDefault();
        showPreloader();

        this.profileLegalAidEditModalOutlet.openModal();

        hidePreloader()
    }
}
